import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { navigate } from 'gatsby'

import * as styles from './modal-form.module.scss'

import Form from '@/components/form/form'

const ModalForm = ({ title, gateContent = [], formtype, location }) => {
  const [show, setShow] = useState(false)
  const [contentSelected, setContentSelected] = useState([])

  const papers = gateContent?.reduce((acc, item) => {
    if (!item) return acc
    const { originalId, externalName } = item
    if (originalId && externalName) {
      const paper = {
        originalId,
        externalName
      }
      acc.push(paper)
    }
    return acc
  }, [])
  useEffect(() => {
    if (typeof window === 'undefined' || !location?.search) return

    const handleSearchChange = () => {
      const search = new URLSearchParams(location?.search)

      const isModalOpen = search.get('open-modal') === 'true'

      if (isModalOpen) {
        if (search.get('content')) {
          const contents = search.get('content').split(',') ?? []
          // Set items as pre-selected
          setContentSelected(contents ?? [])
        }
        setShow(true)
      }
    }

    handleSearchChange()
  }, [location?.search])

  const onHide = () => {
    setShow(false)

    navigate(location?.pathname, {
      replace: true
    })
  }

  const selectClasses = {
    option: (state) =>
      `${styles.selectOption} ${state.isSelected ? styles.selectActive : ''} ${
        state.isFocused ? styles.selectActive : ''
      }`,
    control: () => styles.selectControl,
    valueContainer: () => styles.selectValueContainer,
    menuList: () => styles.selectMenu,
    input: () => styles.selectInput,
    indicatorSeparator: () => styles.selectIndicatorSeparator
  }

  return (
    <Modal show={show} onHide={onHide} contentClassName={styles.modalForm}>
      <Modal.Header closeButton className={styles.modalHeader} />
      <Modal.Body className={styles.modalBody}>
        <Form
          className={styles.form}
          classes={{
            root: styles.form,
            checkbox: styles.checkbox,
            input: styles.input,
            select: selectClasses,
            progressBar: styles.progressBar
          }}
          subtitle={title}
          values={{
            form: 'insurtech',
            downloads: papers
          }}
          contentSelected={contentSelected}
        />
      </Modal.Body>
    </Modal>
  )
}

export default ModalForm
